import FirstStep from '../FirstStep'
import FourthStepDriver from '../FourthStepDriver'
import FourthStepPassenger from '../FourthStepPassenger'
import SecondStepCompany from '../SecondStepCompany'
import SecondStepParticular from '../SecondStepParticular'
import ThirdStepParticularCar from '../ThirdStepParticularCar'
import ThirdStepParticularOther from '../ThirdStepParticularOther'

import { JSX, useEffect, useRef, useState } from 'react'

import classNames from 'classnames'
import FinalStepCompany from 'components/Atoms/Calculator/FinalStepCompany'
import FinalStepParticularDriver from 'components/Atoms/Calculator/FinalStepParticularDriver'
import FinalStepParticularOther from 'components/Atoms/Calculator/FinalStepParticularOther'
import FinalStepParticularPassenger from 'components/Atoms/Calculator/FinalStepParticularPassenger'
import FormContactCompany from 'components/Atoms/Calculator/FormContactCompany'
import { useTranslation } from 'react-i18next'

export default function RightColumn() {
  const [isCompany, setIsCompany] = useState<boolean | null>(null)
  const [isParticularCar, setIsParticularCar] = useState<boolean | null>(null)
  const [isDriver, setIsDriver] = useState<boolean | null>(null)
  const [showCompanyContactForm, setShowCompanyContactForm] = useState(false)

  const [step, setStep] = useState<1 | 2 | 3 | 4 | 5>(1)
  const prevStepRef = useRef<1 | 2 | 3 | 4 | 5>(step)

  const [employees, setEmployees] = useState<number>(0)

  // datos “otro medio”
  const [daysOther, setDaysOther] = useState<number>(0)
  const [timeOther, setTimeOther] = useState<number>(0)

  // datos driver coche propio
  const [daysDriver, setDaysDriver] = useState<number>(0)
  const [distanceDriver, setDistanceDriver] = useState<number>(0)
  const [passengerDriver, setPassengerDriver] = useState<number>(0)

  // datos pasajero coche propio
  const [daysPassenger, setDaysPassenger] = useState<number>(0)
  const [distancePassenger, setDistancePassenger] = useState<number>(0)

  const { t } = useTranslation('calculator')

  useEffect(() => {
    if (typeof window === 'undefined') return

    if (step !== prevStepRef.current && step !== 5) {
      if (window.innerWidth < 768) {
        window.scrollTo({
          top: document.documentElement.scrollHeight,
          behavior: 'smooth',
        })
      }
    }

    prevStepRef.current = step
  }, [step])

  let title = t('calculator.rightColumn.title')
  if (showCompanyContactForm) {
    title = '' // o una key específica si la creas
  } else if (step >= 3 && isCompany !== null) {
    if (isCompany) {
      title = t('calculator.rightColumn.finalStep.company.title')
    } else {
      // PARTICULAR
      // Caso “otro medio de transporte” en el final step
      if (step >= 4 && isParticularCar === false) {
        title = t('calculator.rightColumn.finalStep.particular.titleHours')
      } else {
        // Resto de casos particular (coche, etc.)
        title = t('calculator.rightColumn.finalStep.particular.title')
      }
    }
  }

  const columnClass = classNames(
    'flex',
    'flex-col',
    'gap-4',
    'bg-white/[0.75]',
    'rounded-xl',
    'p-5',
    'sm:p-10',
  )

  const handleCompanyContactClick = () => {
    setShowCompanyContactForm(true)
  }

  // Paso 1 → 2 (empresa vs particular)
  const handleSelectProfile = (value: boolean) => {
    setIsCompany(value)
    setStep(2)
  }

  // Empresa: paso 2 → 3
  const handleCompanyCalculate = (value: number) => {
    if (value <= 0) return

    setEmployees(value)
    setStep(3)
  }

  // Particular: paso 2 → 3 (coche propio vs otro medio)
  const handleSelectParticularTransport = (isCar: boolean) => {
    setIsParticularCar(isCar)
    if (isCar) {
      // Coche propio → ThirdStepParticularCar
      setStep(3)
    } else {
      // Otro medio → ThirdStepParticularOther
      setStep(3)
    }
  }

  // Particular + coche: paso 3 → 4 (driver vs passenger)
  const handleSelectRole = (driver: boolean) => {
    setIsDriver(driver)
    if (driver) {
      // Driver → FourthStepDriver
      setStep(4)
    } else {
      // Passenger → podrías ir a otro flujo o final distinto
      // setStep(4) y luego mostrar FinalStepParticularPassenger, por ejemplo
      setStep(4)
    }
  }

  // Particular + otro medio: paso 3 → 4
  const handleOtherCalculate = (days: number, time: number) => {
    if (days <= 0 || time <= 0) return

    setDaysOther(days)
    setTimeOther(time)
    setStep(4)
  }

  // Driver coche propio: paso 4 → 5
  const handleDriverCalculate = (
    days: number,
    distance: number,
    passenger: number,
  ) => {
    if (days <= 0 || distance <= 0 || passenger <= 0) return

    setDaysDriver(days)
    setDistanceDriver(distance)
    setPassengerDriver(passenger)
    setStep(5)
  }

  // Passenger coche propio: paso 4 → 5
  const handlePassengerCalculate = (days: number, distance: number) => {
    if (days <= 0 || distance <= 0) return

    setDaysPassenger(days)
    setDistancePassenger(distance)
    setStep(5)
  }

  let children: JSX.Element

  // STEP 1
  if (showCompanyContactForm) {
    children = <FormContactCompany />
  } else if (step === 1) {
    children = <FirstStep setIsCompany={handleSelectProfile} />
  }

  // STEP 2
  else if (step === 2) {
    if (isCompany === true) {
      children = <SecondStepCompany onCalculate={handleCompanyCalculate} />
    } else {
      children = (
        <SecondStepParticular
          setIsParticularCar={handleSelectParticularTransport}
        />
      )
    }
  }

  // STEP 3
  else if (step === 3) {
    if (isCompany === true) {
      children = (
        <FinalStepCompany
          employees={employees}
          onContactClick={handleCompanyContactClick}
        />
      )
    } else {
      if (isParticularCar === true) {
        // coche propio → elegir driver/pasajero
        children = <ThirdStepParticularCar setIsDriver={handleSelectRole} />
      } else {
        // otro medio → introducir días/tiempo
        children = (
          <ThirdStepParticularOther onCalculate={handleOtherCalculate} />
        )
      }
    }
  }

  // STEP 4
  else if (step === 4) {
    if (isCompany === true) {
      children = (
        <FinalStepCompany
          employees={employees}
          onContactClick={handleCompanyContactClick}
        />
      )
    } else {
      if (isParticularCar === true && isDriver === true) {
        // driver coche → formulario de 3 datos
        children = <FourthStepDriver onCalculate={handleDriverCalculate} />
      } else if (isParticularCar === true && isDriver === false) {
        // passenger coche → formulario con 2 datos
        children = (
          <FourthStepPassenger onCalculate={handlePassengerCalculate} />
        )
      } else {
        // particular + otro medio → paso final con days/time
        children = (
          <FinalStepParticularOther days={daysOther} time={timeOther} />
        )
      }
    }
  }

  // STEP 5
  else {
    if (isParticularCar === true && isDriver === true) {
      // Driver coche
      children = (
        <FinalStepParticularDriver
          days={daysDriver}
          distance={distanceDriver}
          passenger={passengerDriver}
        />
      )
    } else {
      // Passenger coche
      children = (
        <FinalStepParticularPassenger
          days={daysPassenger}
          distance={distancePassenger}
        />
      )
    }
  }

  return (
    <div className={columnClass}>
      {title && <h2 className="text-2xl font-bold text-gray-800">{title}</h2>}
      {children}
    </div>
  )
}
